import _ from 'lodash';

const transformResponse = (response) => {
  const r = _.chain(response);

  const getCoursewareItem = (item) => ({
    config: _.get(item, 'config'),
    id: _.get(item, 'id'),
    plugin: {
      id: _.get(item, 'plugin.manifest.pluginId'),
      version: _.get(item, 'plugin.manifest.version'),
      entryPoints: _.chain(item).get('plugin.entryPoints')
        .map(({ entryPointPath, ...rest }) => ({ entryPoint: entryPointPath, ...rest }))
        .keyBy('context').value(),
    },
  });

  const parent = r.get('learn.cohort.deployment.0.interactive');

  const enrollmentByStudent = r.get('cohortById.enrollmentByStudent');
  const studentId = enrollmentByStudent.get('accountId').value();
  const scope = enrollmentByStudent.get('getLatestAttemptStudentManualGradeReport.completedWalkable.evaluation.scope');
  const studentScope = { [studentId]: {
    studentId,
    scope: scope.keyBy('sourceId').value(),
  } };

  const parentConfig = getCoursewareItem(parent.value());
  const componentConfigs = parent.get('components').map(getCoursewareItem)
    .keyBy('id').value();

  return {
    parentConfig,
    componentConfigs,
    studentScope,
  };
};

export { transformResponse };
